/**
 * GAP-BACKEND-ADMIN-004 — audience embedded value object (wire shape).
 * Mirrors Awvent.BuildingBlocks.Common.Audiences.AudienceDto. Mode serializes as
 * a number (0 = Everyone, 1 = Specific).
 */
export enum AudienceMode {
    Everyone = 0,
    Specific = 1,
}

export class AudienceDto {
    mode?: AudienceMode = AudienceMode.Everyone;
    teamIds?: Array<string> = [];
    groupIds?: Array<string> = [];
}
